module.exports = __webpack_public_path__ + "img/100.60200d82.png";